export default {
  data() {
    return {
      // input field validations rules. Pass to form controls in array to :rules prop
      // example: :rules=[required, email]
      required: v => !!v || this.$t('required_field'),
      postCode: v => !!v || this.$t('post_code_required'),
      email: v => /.+@.+/.test(v) || this.$t('invalid_email'),
    };
  },

  methods: {
    mapErrorsToInputs(errors) {
      if (errors.response && errors.response.status === 422) {
        Object.keys(errors.response.data.errors).forEach((key) => {
          this.backendErrors[key] = errors.response.data.errors[key];
        });
      }
    },

    // Used when Autocomplete.vue component emits a value
    setAutocompleteValue(item, objectField, idField) {
      if (item) {
        this.item[objectField] = item;
        this.item[idField] = item.id;
      } else {
        this.item[objectField] = null;
        this.item[idField] = null;
      }
    },
  },
};
